import CustomListingColumns from './CustomListingColumns';

export default CustomListingColumns;
